package com.milta.core.localization.translations.es

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Historial de rutas",
    periodLabel = "Período",
    periodLastEightDays = "Últimos 8 días",
    periodSingleDate = "Fecha concreta",
    periodRange = "Intervalo de fechas",
    rangeFromLabel = "Desde",
    rangeToLabel = "Hasta",
    driverFilterLabel = "Repartidor",
    driverFilterAllOption = "Todos los repartidores",
    columnDate = "Fecha",
    columnDriver = "Repartidor",
    columnTotalDeliveries = "Total entregas",
    columnDelivered = "Entregadas",
    columnFailed = "Fallidas",
    viewProofsAction = "Ver comprobantes",
    emptyHistoryMessage = "No se encontró ninguna ruta para este período.",
    errorInvalidPeriod = "El período seleccionado no es válido.",
    screenBTitle = "Historial de comprobantes de entrega",
    routeOfLabel = "Ruta del",
    totalDeliveriesLabel = "entregas",
    deliveredLabel = "entregadas",
    failedLabel = "fallidas",
    backToHistoryAction = "Historial de rutas",
    statusDeliveredBadge = "Entregado",
    statusFailedBadge = "Fallida",
    viewReasonAction = "Ver el motivo",
    hideReasonAction = "Ocultar el motivo",
    photoPlaceholderAlt = "No hay foto disponible",
    photoAlt = "Comprobante de entrega",
    emptyProofsMessage = "No hay comprobantes de entrega disponibles para esta ruta.",
    paginationPrevious = "Anterior",
    paginationNext = "Siguiente",
)
